import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPickSession = {
  name: "getPickSession" as const,
  input: z.object({ id: zExt.objectId() }),
  output: PickSessionSchema.nullable(),
};
